/**
 * Creates the callback used for membership types to populate the rest of the state
 * 
 * @param {Object} membershipType 
 * @param {Object} answers 
 * @param {Object} pricing 
 */
export function createMembershipTypeCallback(membershipType, answers, pricing){
    /**
     * Override the callback for the membership types API
     * 
     * Assigns the answers for the authenticated user (if logged in)
     * Assigns the pricing based on the availabilities selected for the current membership
     * 
     * @param {Object} data API response
     * @returns {Object}
     */
    membershipType.api.callbacks.add(
        'onSuccess',  
        (data, original) => {
            if(original.answers?.code === 200){
                answers.details.value = (original.answers?.data ?? []).reduce(
                    (answers, answer) => ({
                        ...answers,
                        [answer.field_id]: answer.answer
                    }),
                    {}
                )
            }

            if(pricing){
                pricing.details.value = data?.availabilities
            }
        }
    )
}